
import Vue from 'vue';
import {
  appealsAcceptedExtensions,
  appealsAcceptedExtensionsHint,
  appealsAcceptedExtensionsArr,
  appealsAcceptedFileSize,
  checkFiles,
  appealsAvailableCount
} from "@/assets/scripts/file-inputs";

  export default Vue.extend({
  methods: {
    /**
    * Доступные расширения для файлов
    */
    getAppealsAcceptedExtensions() {
      return appealsAcceptedExtensions()
    },

    getAppealsAcceptedExtensionsHint() {
      return appealsAcceptedExtensionsHint()
    },

    getAppealsAcceptedExtensionsArr() {
      return appealsAcceptedExtensionsArr();
    },

    getAppealsAcceptedFileSize() {
      return appealsAcceptedFileSize();
    },

    getAppealsAvailableCount() {
      return appealsAvailableCount();
    },

    /**
     * Проверка файлов
     */
    checkFiles(files: File[]) {
      return checkFiles(files, this.getAppealsAcceptedExtensionsArr(), this.getAppealsAcceptedFileSize());
    },

    /**
    * Форматирование размера файла
    */
    formatFileSize(bytes: number): string {
      if (bytes === 0) return '0 Байт';
      const k = 1024;
      const sizes = ['Байт', 'КБ', 'МБ', 'ГБ'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    /**
    * Получение иконки для типа файла
    */
    getFileIcon(file: File): string {
      const name = file.name.toLowerCase();

      if (name.endsWith('.pdf')) return 'mdi-file-pdf';
      if (name.endsWith('.doc') || name.endsWith('.docx')) return 'mdi-file-word';
      if (name.endsWith('.xls') || name.endsWith('.xlsx')) return 'mdi-file-excel';
      if (name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.png')) return 'mdi-file-image';
      if (name.endsWith('.zip') || name.endsWith('.rar')) return 'mdi-folder-zip';

      return 'mdi-file';
    },

    /**
    * Форма слова "файл" в зависимости от количества
    */
    getFileCountText(count?: number): string {
      const fileCount = count || this.fileList?.length || 0;
      if (fileCount % 10 === 1 && fileCount % 100 !== 11) return '';
      if (fileCount % 10 >= 2 && fileCount % 10 <= 4 && (fileCount % 100 < 10 || fileCount % 100 >= 20)) return 'а';
      return 'ов';
    },

    /**
     * Хинт с информацией о файлах
     */
    getFileHint() {
      return this.getAppealsAcceptedExtensionsHint();
    },

    /**
    * Общий размер всех файлов
    */
    getTotalSize(files: File[]): string {
      if (!files || files.length === 0) {
        return '0 Б';
      }

      const totalBytes = files.reduce((total, file) => {
        return total + (file.size || 0);
      }, 0);

      return this.formatFileSize(totalBytes);
    },

    /**
    * Обрезание имени файла для отображения
    */
    truncateFileName(fileName: string, maxLength: number = 15): string {
      if (fileName.length <= maxLength) return fileName;
      return fileName.substring(0, maxLength - 3) + '...';
    }
  }
});
